{
  "cycle.entite.organisation_domaines": "Domaines de l’organisation",
  "journalAudit.action.org.domain.declared": "Domaine déclaré",
  "journalAudit.action.org.domain.removed": "Domaine retiré",
  "journalAudit.action.org.domain.verification_failed": "Vérification de domaine en échec",
  "journalAudit.action.org.domain.verified": "Domaine vérifié",
  "journalAudit.action.org.ip_restriction.denied": "Requête refusée : adresse hors des plages autorisées",
  "v8c.securite.annuler": "Annuler",
  "v8c.securite.champ.adresse_invalide": "Plage invalide : {{plage}}",
  "v8c.securite.champ.adresses": "Adresses autorisées (une plage CIDR par ligne)",
  "v8c.securite.champ.adresses_aide": "Liste vide : aucune restriction. Le propriétaire de l’organisation en est exempté.",
  "v8c.securite.champ.adresses_cinquante": "50 plages au plus.",
  "v8c.securite.champ.classes": "Types de caractères exigés",
  "v8c.securite.champ.classes_bornes": "Entre 1 et 4 types.",
  "v8c.securite.champ.domaines": "Domaines autorisés aux invitations",
  "v8c.securite.champ.domaines_aide": "Seuls les domaines vérifiés sont proposés (preuve DNS ci-dessous).",
  "v8c.securite.champ.domaines_tous": "Aucun domaine coché : toutes les adresses e-mail sont acceptées.",
  "v8c.securite.champ.duree": "Durée maximale de session",
  "v8c.securite.champ.duree_bornes": "Entre 15 minutes et 30 jours.",
  "v8c.securite.champ.duree_vide": "Non bornée",
  "v8c.securite.champ.longueur": "Longueur minimale du mot de passe",
  "v8c.securite.champ.longueur_bornes": "Entre 12 et 128 caractères.",
  "v8c.securite.champ.second_facteur": "Exiger le second facteur",
  "v8c.securite.champ.unite": "Unité de durée",
  "v8c.securite.champ.verrouillage": "Votre adresse actuelle ({{adresse}}) n’est pas dans ces plages : vous ne pourrez plus agir depuis cette adresse après l’enregistrement.",
  "v8c.securite.code.ADRESSE_NON_AUTORISEE": "Votre adresse n’est pas dans les plages autorisées de l’organisation.",
  "v8c.securite.code.AUTH_POLICY_INVALID": "Réglage invalide : vérifiez les plages, les domaines (vérifiés seulement) et les bornes.",
  "v8c.securite.code.AUTH_POLICY_STALE": "La politique a été modifiée entre-temps.",
  "v8c.securite.code.CONTEXTE_INCOMPLET": "Le contexte de l’organisation est incomplet.",
  "v8c.securite.code.DOMAINE_DANS_LA_POLITIQUE": "Ce domaine est encore autorisé aux invitations : retirez-le d’abord de la politique.",
  "v8c.securite.code.DOMAINE_DEJA_VERIFIE_AILLEURS": "Ce domaine est déjà vérifié par une autre organisation.",
  "v8c.securite.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire.",
  "v8c.securite.code.ORG_ADMIN_REQUIRED": "Réservé à l’administration de l’organisation.",
  "v8c.securite.code.RESOURCE_UNAVAILABLE": "Introuvable dans votre organisation.",
  "v8c.securite.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v8c.securite.code.VALIDATION_ERROR": "Valeur invalide.",
  "v8c.securite.col.actions": "Actions",
  "v8c.securite.col.compte": "Compte",
  "v8c.securite.col.domaine": "Domaine",
  "v8c.securite.col.second_facteur": "Second facteur",
  "v8c.securite.col.statut": "Statut",
  "v8c.securite.dialogue.copie": "Enregistrement copié.",
  "v8c.securite.dialogue.copie_refusee": "Copie refusée par le navigateur : sélectionnez la valeur.",
  "v8c.securite.dialogue.copier": "Copier l’enregistrement",
  "v8c.securite.dialogue.domaine": "Domaine",
  "v8c.securite.dialogue.domaine_repris": "Domaine à reprendre",
  "v8c.securite.dialogue.en_cours": "Vérification en cours…",
  "v8c.securite.dialogue.erreur_declaration": "Déclaration impossible.",
  "v8c.securite.dialogue.erreur_verification": "Vérification impossible.",
  "v8c.securite.dialogue.exemple": "exemple.com",
  "v8c.securite.dialogue.fermer": "Fermer",
  "v8c.securite.dialogue.intro": "Saisissez le domaine, installez l’enregistrement TXT chez votre hébergeur DNS, puis vérifiez.",
  "v8c.securite.dialogue.invalide": "Nom de domaine invalide.",
  "v8c.securite.dialogue.masque": "La preuve DNS s’affiche après la saisie du domaine.",
  "v8c.securite.dialogue.nom": "Nom",
  "v8c.securite.dialogue.obtenir": "Obtenir la preuve DNS",
  "v8c.securite.dialogue.plus_tard": "Réessayez plus tard : la propagation DNS peut prendre du temps.",
  "v8c.securite.dialogue.preuve_titre": "Enregistrement à installer pour {{domaine}}",
  "v8c.securite.dialogue.statut.erreur_de_verification": "Erreur de vérification.",
  "v8c.securite.dialogue.statut.non_verifie": "Non vérifié",
  "v8c.securite.dialogue.statut.preuve_absente_ou_incorrecte": "Preuve absente ou incorrecte : vérifiez l’enregistrement TXT installé.",
  "v8c.securite.dialogue.statut.verification_en_cours": "Vérification en cours",
  "v8c.securite.dialogue.titre": "Vérifier un domaine de l’organisation",
  "v8c.securite.dialogue.type": "Type",
  "v8c.securite.dialogue.valable": "Valable jusqu’à la vérification.",
  "v8c.securite.dialogue.valeur": "Valeur",
  "v8c.securite.dialogue.verifier": "Vérifier maintenant",
  "v8c.securite.domaines.confirmer_retrait": "Confirmer le retrait de {{domaine}}",
  "v8c.securite.domaines.intro": "Un domaine vérifié par une preuve DNS peut être autorisé aux invitations.",
  "v8c.securite.domaines.libelle": "Domaines de l’organisation",
  "v8c.securite.domaines.reprendre": "Reprendre la vérification",
  "v8c.securite.domaines.reprendre_de": "Reprendre la vérification de {{domaine}}",
  "v8c.securite.domaines.reprise_echec": "Preuve toujours introuvable pour {{domaine}}.",
  "v8c.securite.domaines.reprise_erreur": "Vérification impossible.",
  "v8c.securite.domaines.reprise_verifie": "Domaine {{domaine}} vérifié.",
  "v8c.securite.domaines.retirer": "Retirer",
  "v8c.securite.domaines.retirer_de": "Retirer {{domaine}}",
  "v8c.securite.domaines.retrait_empeche": "Retirez-le d’abord des domaines autorisés aux invitations : la politique n’est jamais élargie implicitement.",
  "v8c.securite.domaines.retrait_erreur": "Retrait impossible.",
  "v8c.securite.domaines.titre": "Domaines de l’organisation",
  "v8c.securite.domaines.verifie_le": "Vérifié le {{le}}",
  "v8c.securite.domaines.verifier_un_domaine": "Vérifier un domaine",
  "v8c.securite.domaines.vide": "Aucun domaine déclaré.",
  "v8c.securite.effectif.filtre": "État du second facteur",
  "v8c.securite.effectif.libelle": "Réglage effectif par compte",
  "v8c.securite.effectif.pagination": "{{de}}–{{a}} sur {{total}}",
  "v8c.securite.effectif.precedente": "Page précédente",
  "v8c.securite.effectif.recherche": "Rechercher un compte",
  "v8c.securite.effectif.suivante": "Page suivante",
  "v8c.securite.effectif.titre": "Réglage effectif par compte",
  "v8c.securite.effectif.tronquee": "Liste tronquée aux 200 premiers comptes : précisez la recherche.",
  "v8c.securite.effectif.vide": "Aucun compte ne correspond.",
  "v8c.securite.enregistrer.annuaire_injoignable": "L’annuaire est injoignable : enregistrez à nouveau plus tard pour rattraper ces comptes.",
  "v8c.securite.enregistrer.bouton": "Enregistrer et appliquer",
  "v8c.securite.enregistrer.conflit": "La politique a été modifiée entre-temps : elle a été relue, vérifiez vos réglages puis recommencez.",
  "v8c.securite.enregistrer.erreur": "Enregistrement impossible.",
  "v8c.securite.enregistrer.resume_aide": "Le résumé est calculé sans rien enregistrer.",
  "v8c.securite.enregistrer.resume_d_abord": "Voir le résumé avant application",
  "v8c.securite.enregistrer.succes": "Politique enregistrée et appliquée.",
  "v8c.securite.enregistrer.succes_partiel": "Politique enregistrée ; application partielle : le second facteur n’a pas pu être posé pour ces comptes :",
  "v8c.securite.etat.chargement": "Chargement : {{quoi}}…",
  "v8c.securite.etat.en_cours": "En cours…",
  "v8c.securite.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v8c.securite.etat.reessayer": "Réessayer",
  "v8c.securite.etat.refus": "Accès refusé : {{quoi}}.",
  "v8c.securite.etat_compte.a_configurer": "À configurer à la prochaine connexion",
  "v8c.securite.etat_compte.configure": "Second facteur configuré",
  "v8c.securite.etat_compte.en_echec_apres_application": "En échec après application",
  "v8c.securite.etat_compte.inconnu_de_l_annuaire": "Inconnu de l’annuaire",
  "v8c.securite.etat_compte.non_configure": "Non configuré",
  "v8c.securite.filtre.a_configurer": "À configurer",
  "v8c.securite.filtre.configure": "Configuré",
  "v8c.securite.filtre.en_echec_apres_application": "En échec après application",
  "v8c.securite.filtre.non_configure": "Non configuré",
  "v8c.securite.filtre.tous": "Tous",
  "v8c.securite.intro": "Second facteur, durée de session, domaines et adresses autorisés : ces règles s’appliquent à tous les membres de l’organisation.",
  "v8c.securite.onglet.membres": "Membres",
  "v8c.securite.onglet.securite": "Sécurité de connexion",
  "v8c.securite.onglets": "Onglets de l’organisation",
  "v8c.securite.politique.adresses": "Adresses autorisées",
  "v8c.securite.politique.domaines": "Domaines autorisés aux invitations",
  "v8c.securite.politique.exige": "Exigé",
  "v8c.securite.politique.lecture_seule": "Lecture seule : vous ne tenez pas le droit de régler la sécurité de connexion.",
  "v8c.securite.politique.libelle": "Politique en vigueur",
  "v8c.securite.politique.mot_de_passe": "Mot de passe",
  "v8c.securite.politique.mot_de_passe_valeur": "{{n}} caractères au moins, {{c}} type(s) de caractères",
  "v8c.securite.politique.non_exige": "Non exigé",
  "v8c.securite.politique.second_facteur": "Second facteur",
  "v8c.securite.politique.session": "Durée maximale de session",
  "v8c.securite.politique.titre": "Politique en vigueur",
  "v8c.securite.politique.tous_domaines": "Tous les domaines",
  "v8c.securite.politique.toutes_adresses": "Aucune restriction d’adresse",
  "v8c.securite.politique.valeurs_par_defaut": "Valeurs par défaut : session non bornée, {{n}} caractères au moins, {{c}} type de caractères.",
  "v8c.securite.politique.version": "Version {{v}}, modifiée le {{le}} par {{par}}.",
  "v8c.securite.reglages.titre": "Réglages",
  "v8c.securite.resume.aucun_effet": "Aucun effet sur les comptes, les sessions ni les invitations.",
  "v8c.securite.resume.erreur": "Résumé impossible.",
  "v8c.securite.resume.invitations": "Les invitations hors des domaines cochés seront refusées.",
  "v8c.securite.resume.second_facteur": "{{n}} personnes devront configurer le second facteur.",
  "v8c.securite.resume.second_facteur_dont_vous": "{{n}} personnes devront configurer le second facteur, dont vous.",
  "v8c.securite.resume.sessions": "Les sessions plus longues que la nouvelle durée seront fermées.",
  "v8c.securite.resume.titre": "Résumé avant application",
  "v8c.securite.session.heures": "{{n}} heures",
  "v8c.securite.session.jours": "{{n}} jours",
  "v8c.securite.session.minutes": "{{n}} minutes",
  "v8c.securite.session.non_bornee": "Non bornée",
  "v8c.securite.statut.erreur_de_verification": "Erreur de vérification",
  "v8c.securite.statut.non_verifie": "Non vérifié",
  "v8c.securite.statut.preuve_absente_ou_incorrecte": "Preuve absente ou incorrecte",
  "v8c.securite.statut.verification_en_cours": "Vérification en cours",
  "v8c.securite.statut.verifie": "Vérifié",
  "v8c.securite.titre": "Sécurité de connexion de l’organisation",
  "v8c.securite.unite.heures": "heures",
  "v8c.securite.unite.jours": "jours",
  "v8c.securite.unite.minutes": "minutes"
}
